import TenancyCardSmall from './TenancyCardSmall';

export default TenancyCardSmall;